import { ThemeEvents, CartUpdateEvent } from '@theme/events';

if (!window.customElements.get('cart-progress')) {
  window.customElements.define(
    'cart-progress',
    class CartProgress extends HTMLElement {
      constructor() {
        super();
        this.debounceTimeout = null;
      }

      connectedCallback() {
        // Initial draw: use data-progress only (no fetch)
        this.animateCart(false);

        document.addEventListener('cart:update', () => {
          clearTimeout(this.debounceTimeout);
          this.debounceTimeout = setTimeout(() => this.animateCart(true), 650);
        });
      }

      async fetchCart() {
        try {
          const res = await fetch('/cart.js');
          if (!res.ok) throw new Error('Cart fetch failed');
          return await res.json();
        } catch (error) {
          console.error('Error fetching cart:', error);
          return null;
        }
      }

      async animateCart(fromEvent) {
        const progressBar = document.querySelector('.ns-progress');
        let cart = null;

        if (fromEvent) {
          cart = await this.fetchCart();
        }

        const cartTotal = fromEvent
          ? cart?.total_price || 0
          : parseFloat(progressBar?.dataset.progress || 0);

        const targetGiftsContainer = document.querySelector('.target-gifts');
        const locks = document.querySelectorAll('.target-locks .target');

        // Gift blocks
        const giftBlocks = Array.from(document.querySelectorAll('.ns-target-gift'));
        if (giftBlocks.length === 0) return;

        const existingGifts = new Set();
        giftBlocks.forEach((gift) => {
          const id = gift.dataset.giftId;
          if (!existingGifts.has(id)) {
            if (!targetGiftsContainer.contains(gift)) {
              targetGiftsContainer.appendChild(gift);
            }
            existingGifts.add(id);
          }
        });

        targetGiftsContainer.classList.add(`size-${giftBlocks.length}`);

        // Progress bar logic
        const progressFill = document.querySelector('.ns-progress-fill');
        const gap = 100;
        let currentTarget = null;
        let nextTarget = null;

        locks.forEach((lock, i) => {
          const targetVal = parseFloat(lock.dataset.target);
          if (cartTotal >= targetVal) {
            currentTarget = lock;
            nextTarget = locks[i + 1];
            setTimeout(() => {
              lock.classList.add('active');
            }, 300 * i);
          }
        });

        if (currentTarget && nextTarget) {
          const cVal = parseFloat(currentTarget.dataset.target);
          const nVal = parseFloat(nextTarget.dataset.target);
          const extraVal = (cartTotal - cVal) / (nVal - cVal);
          const barIndex = Array.from(locks).indexOf(currentTarget);
          const barWidth = barIndex * gap + gap * extraVal;
          setTimeout(() => {
            progressFill.style.width = `${barWidth}%`;
          }, 200);
        } else {
          progressFill.style.width = '100%';
        }

        // Gift logic (only run if we have cart data)
        if (cart) {
          const updates = {};
          let needsUpdate = false;

          for (let gift of giftBlocks) {
            const giftTarget = parseFloat(gift.dataset.giftTarget);
            const giftId = parseInt(gift.dataset.giftId, 10);
            const classList = gift.classList;

            const hasGift = cart.items?.some((item) => item.variant_id === giftId);
            const noAppGift = classList.contains('noappgift');
            const isMultiGift = classList.contains('multigift');

            // Flip visibility of gift messages
            const giftAddedEl = gift.querySelector('[data-gift-added-message]');
            const giftNotAddedEl = gift.querySelector('[data-gift-not-added-message]');
            if (giftAddedEl) giftAddedEl.style.display = hasGift ? 'inline' : 'none';
            if (giftNotAddedEl) giftNotAddedEl.style.display = hasGift ? 'none' : 'inline';

            // Only push an update if state is wrong
            if (cartTotal >= giftTarget && !hasGift && noAppGift) {
              updates[giftId] = 1;
              needsUpdate = true;
            } else if (cartTotal < giftTarget && hasGift && noAppGift) {
              updates[giftId] = 0;
              needsUpdate = true;
            } else if (isMultiGift && !hasGift) {
              updates[giftId] = 1;
              needsUpdate = true;
            }
          }

          if (needsUpdate) {
            this.updateCart(updates);
          }
        }
      }

      updateCart(updates) {
        const formData = new URLSearchParams();

        for (const [id, qty] of Object.entries(updates)) {
          formData.append(`updates[${id}]`, qty);
        }

        const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
          .map((el) => (el instanceof HTMLElement ? el.dataset.sectionId : null))
          .filter(Boolean);

        if (sectionIds.length) {
          formData.append('sections', sectionIds.join(','));
        }

        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: formData.toString(),
        })
          .then((res) => res.json())
          .then((data) => {
            const event = new CartUpdateEvent({ data });
            document.dispatchEvent(event);
          })
          .catch((err) => console.error('Cart update error:', err));
      }
    }
  );
}